import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Services.module.css";
import { HOME_SERVICES } from "../../../data/services";
import { Animate } from "../../animations";

const Services = () => {
  return (
    <section className={styles.services}>
      <div className={styles.servicesInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.servicesHeading}>Our Services</h4>
          <h1 className={styles.servicesTitle} id="heading-large">
            Everything You Need to Study Abroad
          </h1>
          <p className={styles.servicesDescription}>
            From choosing the right university to landing in your dream country —
            we handle every step so you can focus on your future.
          </p>
        </Animate>
        {HOME_SERVICES.map((service, index) => (
          <Animate
            key={service.title}
            variant={index % 2 === 0 ? "slideRight" : "slideLeft"}
            delay={80}
          >
            <div
              className={`${styles.servicesSection} ${
                index % 2 === 1 ? styles.servicesSectionReverse : ""
              } anim-hover-lift`}
            >
              <img
                src={service.image}
                alt={service.title}
                className={styles.servicesImage}
              />
              <div className={styles.servicesContent}>
                <h2 id="heading-md">{service.title}</h2>
                <p>{service.description}</p>
                <NavLink to={service.route} className={styles.readMoreLink}>
                  Learn more
                </NavLink>
              </div>
            </div>
          </Animate>
        ))}
        <Animate variant="fadeUp" delay={100}>
          <div className="text-center mt-10 mb-4">
            <NavLink to="/pricing">
              <button className="btn-primary">View All Packages & Pricing</button>
            </NavLink>
          </div>
        </Animate>
      </div>
    </section>
  );
};

export default Services;
